import React from 'react';
import './AdminHome.css';
import { getUserInfo } from '../utils/auth';
import AdminIcon from './AdminIcons';
import { getNavGroups, getStandaloneItems } from './adminNav';

const AdminHome = ({ onNavigate }) => {
  const userInfo    = getUserInfo();
  const displayName = userInfo.display_name || userInfo.username || 'Admin';
  const role        = (userInfo.role || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

  // Same list the sidebar renders, so Home only ever offers what this role can actually open.
  const standalone = getStandaloneItems();
  const sections = [
    ...(standalone.length ? [{ key: 'standalone', label: 'Your class', items: standalone }] : []),
    ...getNavGroups(),
  ];

  return (
    <div className="admin-home">
      <div className="home-welcome">
        <h1>Welcome, {displayName}!</h1>
        <p>
          Central Texas Tamil Academy &nbsp;·&nbsp;
          <span className="home-role-badge">{role}</span>
        </p>
      </div>

      {sections.length === 0 ? (
        <div className="home-no-perms">
          <div className="home-no-perms-icon"><AdminIcon name="shield" size={40} /></div>
          <p>You don't have access to any admin features yet.</p>
          <p className="home-no-perms-hint">
            Contact a super admin to update your role permissions.
          </p>
        </div>
      ) : (
        sections.map(section => (
          <section className="home-section" key={section.key}>
            <h2 className="home-section-title">{section.label}</h2>
            <div className="home-cards">
              {section.items.map(item => (
                <button
                  key={item.page}
                  className="home-card"
                  onClick={() => onNavigate && onNavigate(item.page)}
                >
                  <span className="home-card-icon"><AdminIcon name={item.icon} size={24} /></span>
                  <span className="home-card-text">
                    <span className="home-card-title">{item.label}</span>
                    <span className="home-card-desc">{item.desc}</span>
                  </span>
                </button>
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
};

export default AdminHome;
